import React from "react";
import {
    StepId,
    STEP_LOCATION,
    STEP_SERVICE,
    STEP_PROVIDER,
    STEP_AVAILABILITY,
    STEP_REGISTER,
    STEP_CONFIRMATION,
} from "../bookingSlice.types";
import {
    useClientPortalSelector,
    selectBooking,
} from "../../../redux";
import Location from "../components/Location";
import Service from "../components/Service";
import Provider from "../components/Provider";
import Availability from "../components/Availability";
import Register from "../components/Register";
import Confirmation from "../components/Confirmation";
import { BookingType } from "types/appointmentBooking";

type StepComponentRegistry = {
    [K in StepId]: React.ComponentType;
};

const stepComponents: StepComponentRegistry = {
    [STEP_LOCATION]: Location,
    [STEP_SERVICE]: Service,
    [STEP_PROVIDER]: Provider,
    [STEP_AVAILABILITY]: Availability,
    [STEP_REGISTER]: Register,
    [STEP_CONFIRMATION]: Confirmation,
};

export function useStepComponentResolver() {
    const { session } = useClientPortalSelector(selectBooking);

    const getStepComponent = (step: StepId): React.ComponentType => {
        if (step === STEP_SERVICE && session.bookingType === BookingType.CLASS) {
            return stepComponents[STEP_PROVIDER];
        }

        return stepComponents[step];
    };

    return { getStepComponent };
}
